<template>
  <div class="content">
    <div>
      <TabRouter />
      <md-card>
        <md-card-content>
          <transition name="fade" mode="out-in">
            <keep-alive> <router-view></router-view> </keep-alive>
          </transition>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import TabRouter from '../../components/TabsRouter.vue';

export default {
  components: {
    TabRouter,
  },
};
</script>

<style scoped></style>
